"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverseWrappedProperties = traverseWrappedProperties;
exports.traverseWrappedPropertiesDistinct = traverseWrappedPropertiesDistinct;
exports.getWrappedProperties = getWrappedProperties;
exports.validateTree = validateTree;
const functions_1 = require("./functions");
/**
 * przegląda drzewo komponentów Vue w poszukiwaniu tych które pracująna IWrappedProperty
 * @param rootElementOrComponent root komponent
 * @param cb callback zwracjący element, gdy callback zwróci false to proces jest przerywany
 * @param propName nazwa property, domyślnie "model"
 * @returns
 */
function traverseWrappedProperties(cmp, cb, propName = 'model') {
    var _a;
    if (cmp.__vnode) {
        cmp = cmp.__vnode;
    }
    if (cmp._) {
        cmp = cmp._;
    }
    if (cmp.component) {
        cmp = cmp.component;
    }
    if ((_a = cmp.subTree) === null || _a === void 0 ? void 0 : _a.component) {
        cmp = cmp.subTree.component;
    }
    const children = cmp.subTree ? cmp.subTree.children : cmp.children;
    if (!children) {
        return;
    }
    if (typeof children === 'string') {
        return;
    }
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const model = child.props ? child.props[propName] : null;
        if (model && (0, functions_1.isWrappedProperty)(model)) {
            if (cb(model, child) === false) {
                return false;
            }
        }
        if (traverseWrappedProperties(child, cb, propName) === false)
            return false;
    }
    return true;
}
/**
 *
 * @param cmp
 * @param cb
 * @param propName
 */
function traverseWrappedPropertiesDistinct(cmp, cb, propName = 'model') {
    const paths = new Set();
    traverseWrappedProperties(cmp, (prop, scmp) => {
        if (!paths.has(prop)) {
            paths.add(prop);
            return cb(prop, scmp);
        }
    }, propName);
}
/**
 * Pobiera listę property które są atrybutem komponentów we wskazanej gałęzi html
 * @param cmp element html
 * @param propName własciwośc komponentu w którym przekazywany jest schemat, domyślnie "model"
 * @returns
 */
function getWrappedProperties(cmp, propName = 'model') {
    const result = new Set();
    traverseWrappedProperties(cmp, (prop /*, scmp*/) => {
        result.add(prop);
    }, propName);
    return result;
}
/**
 *
 * @param cmp komponent bazowy
 * @param propName
 * @returns
 */
function validateTree(cmp, propName = 'model') {
    const result = [];
    traverseWrappedPropertiesDistinct(cmp, (prop /*, _*/) => {
        const error = prop.$validate();
        if (error)
            result.push(error);
    }, propName);
    return result;
}
//# sourceMappingURL=getWrappedProperties.js.map